import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, FormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSelectModule } from '@angular/material/select';
import { RitwikTransmissionService } from '../../../services/raintree/Transmission/ritwik.transmission.service';
import { PincodeDetailsService } from '../../../services/raintree/Transmission/pincode-details.service';
import { ToastrService } from 'ngx-toastr';
import { CommonUtilService } from '../../../services/common-util/common-util.service';

@Component({
  selector: 'app-comments',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatSelectModule,
    MatAutocompleteModule
  ],
  templateUrl: './comments.component.html',
  styleUrl: './comments.component.scss'
})
export class CommentsComponent {

  workers:any[]=[];

  @Input() rowData:any;

  @Input() visit!:{selectedFeedbacks:any[],feedbackList:any[],selectedWorkers:any[],comment:string};//workerList:any[],
  @Input() memDetails!:{familyCode:string,contact:string};
  @Input() addressDetails!:{pincode:number|null,state:string,stateList:string[],district:string,districtList:string[],landmark:string,address:string}
  @Input() flow!:string;
  @Input() visited!:boolean;

  @Output() visitEmitter:EventEmitter<any>=new EventEmitter();
  @Output() detailsEmitter:EventEmitter<any>=new EventEmitter();
  @Output() addressEmitter:EventEmitter<any>=new EventEmitter();
  @Output() choiceEmitter:EventEmitter<string>=new EventEmitter();
  @Output() step:EventEmitter<number>=new EventEmitter();

  counter:number[]=[1];
  wrkrValidnErr:boolean[]=[];
  workerError:string[]=[];
  pincodeError='';
  wrkrPointer=0;
  workerName='';
  choice='';
  constructor(
    private ritwikTransmission:RitwikTransmissionService,
    private pincodeDetails:PincodeDetailsService,
    public toaster:ToastrService,
    public utilService:CommonUtilService
  ){}
  
  ngOnInit(){
    console.log(this.visit.selectedFeedbacks);
    
    
    if(this.visited){
      this.toaster.success('Please change feedback to \'Current address changed\' to enable the related inputs (pincode, state, district, address and landmark).','IMPORTANT!!');
    }

    if(this.visit.selectedWorkers.length>1){
      this.counter=this.visit.selectedWorkers.map((val)=>1);
    }
    // console.log(this.visit.selectedWorkers);
    // if(this.addressDetails.pincode&&this.flow==='visit')
    //   this.searchPincode();
  }

  isFeedbackDisabled(index:number){

    if(
      (index===0 && this.visit.selectedFeedbacks.find((f)=> f.feedbackCd===2 || f.feedbackCd===4)) ||
      (index===1 && this.visit.selectedFeedbacks.find((f)=> f.feedbackCd===1 || f.feedbackCd===3 || f.feedbackCd===4)) ||
      (index===2 && this.visit.selectedFeedbacks.find((f)=> f.feedbackCd===2)) ||
      (index===3 && this.visit.selectedFeedbacks.find((f)=> f.feedbackCd!==3 && f.feedbackCd!==-1)) ||
      (index===4 && this.visit.selectedFeedbacks.find((f)=> f.feedbackCd===4)) ||
      (index===5 && this.visit.selectedFeedbacks.find((f)=> f.feedbackCd===3 || f.feedbackCd===4)) ||
      (index===6 && this.visit.selectedFeedbacks.find((f)=> f.feedbackCd===4)) ||
      (this.visit.selectedFeedbacks.find((feedback)=>feedback.feedbackCd===this.visit.feedbackList[index].feedbackCd))
    ){
      return true;
    }
    
    return false;
  }
  removeFeedback(index:number,count:number){
    if(count>1)
      this.visit.selectedFeedbacks=this.visit.selectedFeedbacks.filter((fdbk,i)=>i!==index);
    else
      this.visit.selectedFeedbacks[0]={feedbackCd:-1, feedbackMsg:''};
    
  }

  isWorkerDisabled(index:number){
    if(this.visit.selectedWorkers.find((worker)=>worker&&worker.ritwikCode===this.workers[index].ritwikCode))
      return true;
    return false;
  }
  addWorker(){
    if(this.counter.length<3){
      this.counter.push(1);
      this.visit.selectedWorkers.push({ritwikCode:'',fullName:'',state:'',district:'',workerType:''});
    }
    console.log(this.counter);
    
  }
  removeWorker(index:number){
    this.workerError[index]='';
    this.wrkrValidnErr[index]=false;

    
    if(this.counter.length>1){
      this.visit.selectedWorkers=this.visit.selectedWorkers.filter((val,i)=>i!==index);
      this.counter.pop();
    }
    else{
      this.visit.selectedWorkers[0]={ritwikCode:'',fullName:'',state:'',district:'',workerType:''};
    }
  }
  setWorkerField(index:number){
    if(this.visit.selectedWorkers[index]){
      if(this.wrkrPointer===index){
        this.workerName=this.visit.selectedWorkers[index].fullName
        return this.workerName;
      }
      else{
        return this.visit.selectedWorkers[index].fullName;
      }
    }
    else{
      if(this.wrkrPointer===index){
        return this.workerName;
      }
      else{
        return '';
      }
    }
      
  }
  searchWorker(){
    console.log('in search worker',this.workerName);
    
    if(this.workerName.length<3){
      this.visit.selectedWorkers[this.wrkrPointer]=undefined;
      this.workers=[];
      this.visitEmitter.emit(this.visit);
      this.wrkrValidnErr[this.wrkrPointer]=false;
      this.workerError[this.wrkrPointer]='';
      return;
    }
    
    this.ritwikTransmission.getWorkerList(this.workerName).subscribe({
      next:(response)=>{
        console.log(response);
        
        if(response.error){
          this.workers=[];
          this.visit.selectedWorkers[this.wrkrPointer]=undefined;
          this.workerError[this.wrkrPointer]=response.message;
          this.visitEmitter.emit(this.visit);
        }
        else{
          this.workerError[this.wrkrPointer]='';
          response.data=response.data.filter((worker:any)=>{
            return !this.visit.selectedWorkers.find((wrkr)=>wrkr&&(worker.ritwikCode===wrkr.ritwikCode));
          });
          this.workers=response.data;
          this.validateWorker();
        }
      },
      error:(err)=>{
        this.workers=[];
        this.visit.selectedWorkers[this.wrkrPointer]=undefined;
        this.workerError[this.wrkrPointer]=err;
        
        this.visitEmitter.emit(this.visit);
      }
    })
  }

  validateWorker(){
    
    let validated=this.workers.filter((val)=>{
      console.log(this.workerName.toUpperCase());//val.fullName.toUpperCase()
      
      return val.fullName.toUpperCase()===this.workerName.toUpperCase();
    });
    
    if(validated.length!==1){
      this.wrkrValidnErr[this.wrkrPointer]=true;
      this.visit.selectedWorkers[this.wrkrPointer]=undefined;
      this.visitEmitter.emit(this.visit);
    }
    else{
      
      this.wrkrValidnErr[this.wrkrPointer]=false;
      this.workerError[this.wrkrPointer]='';
      this.visit.selectedWorkers[this.wrkrPointer]=validated[0];
      this.workerName=this.visit.selectedWorkers[this.wrkrPointer].fullName;
      
      this.visitEmitter.emit(this.visit);
    }
  }

  searchPincode(){
    if(!this.addressDetails.pincode||this.addressDetails.pincode < 99999){
      this.resetPinDetails();
      this.addressEmitter.emit(this.addressDetails);
      return;
    }
    this.pincodeDetails.fetchPincodeDetails(this.addressDetails.pincode.toString()).subscribe({
      next:(response)=>{
        console.log(response);
        
        if(response.error){
          this.pincodeError=response.message.substring(0,14);
          this.addressDetails.pincode=null;
          this.resetPinDetails();
          this.addressEmitter.emit(this.addressDetails);
        }
        else{
          this.pincodeError='';
          this.addressDetails.districtList=response.data.districts;
          this.addressDetails.district=(this.addressDetails.districtList.length===1)?this.addressDetails.districtList[0]:'';
          this.addressDetails.stateList=response.data.states;
          this.addressDetails.state=(this.addressDetails.stateList.length===1)?this.addressDetails.stateList[0]:'';
        }
        this.addressEmitter.emit(this.addressDetails);
      },
      error:(err)=>{
        this.pincodeError = err.substring(0,14);
        this.addressDetails.pincode = null;
        this.resetPinDetails();
        this.addressEmitter.emit(this.addressDetails);
      }
    });
  }

  resetPinDetails() {
    this.addressDetails.district = '';
    this.addressDetails.districtList = [];
    this.addressDetails.state = '';
    this.addressDetails.stateList = [];
  }

  addressDisabled(){
    if(this.visit.selectedFeedbacks.find((feedback)=>feedback.feedbackCd===5))
      return false;
    return true;
  }

  onContactKeydown(event:KeyboardEvent){
    if(!this.memDetails.contact){
      if(event.key.match(/^[5-9]$/)===null&&event.key!=='Backspace'&&event.key!=='ArrowRight'&&event.key!=='ArrowLeft')
        event.preventDefault();
    }
    else{
      if(event.key.match(/^[0-9]$/)===null&&event.key!=='Backspace'&&event.key!=='ArrowRight'&&event.key!=='ArrowLeft')
        event.preventDefault();
    }
  }
  onAddressKeydown(event:KeyboardEvent){
    if(event.key.match(/^[A-Za-z0-9\.; ,/&()-]$/)===null&&event.key!=='Backspace'&&event.key!=='ArrowRight'&&event.key!=='ArrowLeft')
      event.preventDefault();
  }
  onLandmarkKeydown(event:KeyboardEvent){
    if(event.key.match(/^[A-Za-z0-9 ()-]$/)===null&&event.key!=='Backspace'&&event.key!=='ArrowRight'&&event.key!=='ArrowLeft')
      event.preventDefault();
  }

  onSubmit(form:FormGroup){
    if(form.invalid){
      form.markAllAsTouched();
      document.getElementsByClassName('ng-invalid')[1].scrollIntoView({block:'start',behavior:'smooth'});
      return;
    }
    if((this.workerError.length>0&&this.workerError.every((val)=>val!==''))||(this.wrkrValidnErr.length>0&&this.wrkrValidnErr.every((val)=>val!==false))){
      this.toaster.error('Error in worker selection, please remove any unwanted worker field or type and reselect worker from list', 'Error');
      return;
    }
      
    if(this.pincodeError){
      this.toaster.error('Error in pincode entry','Error');
      return;
    }

    if(this.flow==='visit')
      this.addressEmitter.emit(this.addressDetails);
    
    this.choiceEmitter.emit(this.choice);
  }
}
